import { gql } from '@apollo/client';

export const ResetPasswordQuery = gql`
  mutation ResetPassword($token: String!, $password1: String!) {
    resetPassword(token: $token, password1: $password1)
  }
`;
